import { z } from 'zod';
export const UsageSummarySchema = z.object({
    period_start: z.string(),
    period_end: z.string(),
    active_engineers: z.number(),
    prs_reviewed: z.number(),
    storage_gb: z.string().or(z.number()),
    api_requests: z.number(),
    last_aggregated_at: z.string().optional(),
});
export const UsageHistoryResponseSchema = z.object({
    periods: z.array(UsageSummarySchema),
});
//# sourceMappingURL=usage.js.map